import React from 'react';
import { PageLayout } from '@/shared/layout';
import { Button, Card, Badge, Table } from '@/components/ui';
import { useAuth } from '@/core/auth/AuthContext';
import { useCompany } from './hooks/useCompany';
import { AuthButton } from '@/core/permissions/AuthButton';
import { AuthMask } from '@/core/permissions/AuthMask';
export default function CompanyBillingPage() {
  const { profile } = useAuth();
  const companyId = profile?.company_id;
  const { company, isLoading } = useCompany(companyId);

  const breadcrumbs = [
    { label: 'Công ty', path: '/company' },
    { label: 'Thanh toán' }
  ];

  return (
    <PageLayout
      title="Gói dịch vụ & Thanh toán"
      description="Quản lý gói dịch vụ hiện tại, hóa đơn và thông tin thanh toán của bạn."
      breadcrumbs={breadcrumbs}
      isLoading={isLoading}
    >
      <div className="space-y-8">
        {/* Current Plan Card */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <Card className="lg:col-span-2 p-6 overflow-hidden relative border-os-primary/20">
            <div className="absolute top-0 right-0 w-32 h-32 bg-os-primary/5 rounded-full -mr-16 -mt-16" />
            <div className="relative">
              <div className="flex justify-between items-start mb-6">
                <div>
                  <Badge variant="info" className="mb-2  tracking-widest text-[10px]">Gói hiện tại</Badge>
                  <h3 className="text-3xl font-bold text-slate-900">{company?.subscription_plan_code?.toUpperCase() || 'FREE'}</h3>
                </div>
                <div className="text-right">
                  <p className="text-sm text-slate-500 mb-1">Gia hạn tiếp theo</p>
                  <p className="text-lg font-semibold text-slate-900">15/05/2026</p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-6 border-y border-slate-100 mb-6">
                <div>
                  <p className="text-xs text-slate-400  font-bold mb-1">Dự án tối đa</p>
                  <p className="text-lg font-semibold">{company?.max_projects || 5}</p>
                </div>
                <div>
                  <p className="text-xs text-slate-400  font-bold mb-1">Thành viên tối đa</p>
                  <p className="text-lg font-semibold">{company?.max_users || 10}</p>
                </div>
                <div>
                  <p className="text-xs text-slate-400  font-bold mb-1">Tài sản tối đa</p>
                  <p className="text-lg font-semibold">{company?.max_assets || 100}</p>
                </div>
              </div>

              <div className="flex gap-3">
                <AuthButton module="companies" action="manage_billing" variant="primary">
                  Nâng cấp gói ngay
                </AuthButton>
                <AuthButton module="companies" action="manage_billing" variant="outline">
                  Quản lý phương thức thanh toán
                </AuthButton>
              </div>
            </div>
          </Card>

          <Card className="p-6 bg-slate-50 border-none">
            <h4 className="font-bold text-slate-900 mb-4">Chi tiết thanh toán</h4>
            <div className="space-y-4 text-sm">
              <div className="flex justify-between pb-3 border-b border-slate-200">
                <span className="text-slate-500">Mã khách hàng</span>
                <span className="font-medium">#CU-{company?.id.substring(0, 8)}</span>
              </div>
              <div className="flex justify-between pb-3 border-b border-slate-200">
                <span className="text-slate-500">Chu kỳ thanh toán</span>
                <span className="font-medium text-blue-600">Hàng tháng</span>
              </div>
              <div className="flex justify-between pb-3 border-b border-slate-200">
                <span className="text-slate-500">Phí dịch vụ</span>
                <span className="font-medium">
                  <AuthMask module="companies" action="manage_billing" value="2,500,000đ" /> / tháng
                </span>
              </div>
              <div className="pt-2">
                <p className="text-xs text-slate-400 italic">Giá đã bao gồm thuế VAT 8%.</p>
              </div>
            </div>
          </Card>
        </div>

        {/* Billing History */}
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-slate-900">Lịch sử hóa đơn</h3>
          <Card>
            <Table
              columns={[
                { key: 'id', title: 'Mã hóa đơn' },
                { key: 'date', title: 'Ngày thanh toán' },
                { key: 'amount', title: 'Số tiền' },
                { key: 'status', title: 'Trạng thái', render: (val: string) => <Badge variant="success">{val}</Badge> },
                { key: 'action', title: '', render: () => <Button variant="ghost" size="sm" icon="ri-download-line">Tải xuống</Button> }
              ]}
              data={[
                { id: 'INV-2026-003', date: '15/04/2026', amount: <AuthMask module="companies" action="manage_billing" value="2,500,000đ" />, status: 'Hoàn tất' },
                { id: 'INV-2026-002', date: '15/03/2026', amount: <AuthMask module="companies" action="manage_billing" value="2,500,000đ" />, status: 'Hoàn tất' },
                { id: 'INV-2026-001', date: '15/02/2026', amount: <AuthMask module="companies" action="manage_billing" value="2,500,000đ" />, status: 'Hoàn tất' },
              ]}
            />
          </Card>
        </div>
      </div>
    </PageLayout>
  );
}
